import React from 'react';
import { Button, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import i18n from 'utils/I18n';
import LoadMoreSpinner from 'component/common/LoadMoreSpinner';

import { createAction } from 'utils';
import { getMessageTime } from 'utils/DateTimeUtils';
import { processDeepLink } from 'utils/UrlUtils';

import './InboxContent.scss';
import { CUSTOM_DEEP_LINK_SCHEMA } from 'utils/Config';
import { deepLinkRootPath } from 'utils/WeChatUtil'
import { mobileDetectIsInMainNav } from 'component/common/navigator/NavigatorUtils'


const MessageLinkSection = ({
  messageDetail,
  onClick,
}) => {
  if (!messageDetail?.url) {
    return null;
  };

  return (
    <>
      <Button
        disabled={messageDetail.url_disabled}
        className="content_button button-large"
        onClick={onClick}
      >
        {i18n.t('seeMore')}
      </Button>
      {
        messageDetail?.url_disabled && (
          <div className='message-detail-coupon-not-existed tag-menu-1'>
            {i18n.t('message_detail_coupon_not_existed')}
          </div>
        )
      }
    </>
  );
};

@connect(({ inboxMessages, users }) => ({
  ...inboxMessages,
  language: users.language,
}))
class InboxContent extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.loadDetail();
  }

  componentDidUpdate(preProps) {
    if (preProps.messageId !== this.props.messageId) {
      this.loadDetail();
    }
    if (preProps.language !== this.props.language && this.props.isDetailPage) {
      this.loadDetail();
    }
  }

  loadDetail() {
    const messageID = Number(this.props.messageId);
    this.props.dispatch(
      createAction('inboxMessages/getMessageDetail')({
        messageID,
      }),
    );
  }

  linkButtonDidClicked(link, clickTrackUrl) {
    console.log('link: ', link, 'click_track_url: ', clickTrackUrl);
    if (clickTrackUrl) {
      fetch(`${clickTrackUrl}?track_only=1`);
    }
    const re = new RegExp(`${CUSTOM_DEEP_LINK_SCHEMA}.*://`, "g");
    if (re.exec(link)) {
      const webUrl = processDeepLink(link);
      console.log('webUrl', webUrl);
      if (webUrl !== '') {
        const isRootPath = mobileDetectIsInMainNav(webUrl)
        if (!isRootPath) {
          this.props.history.push(webUrl)
          return
        }        
        deepLinkRootPath({ pathname: webUrl, history: this.props.history })
      }
    } else {
      window.location.href = link;
    }
  }

  render() {
    const messageDetail = this.props.messageDetail;
    const messageDetailLoading = this.props.messageDetailLoading;
    return (
      <div
        className={
          this.props.isDetailPage ? 'inbox_detail_content' : 'inbox_content'
        }
      >
        {messageDetailLoading && <LoadMoreSpinner />}
        <div className="content_title headline">{messageDetail?.title}</div>
        <div className="content_date body-1">
          {messageDetail?.creation_date
            ? getMessageTime(messageDetail.creation_date)
            : ''}
        </div>
        {messageDetail?.photo_url && (
          <div className="content_image_container">
            <Image
              className="content_image"
              src={messageDetail.photo_url}
              placeholder="/inbox/placeholder_image.png"
            />
          </div>
        )}
        <div className="content_content field-text">{messageDetail?.content}</div>
        <MessageLinkSection
          messageDetail={messageDetail}
          onClick={() => this.linkButtonDidClicked(messageDetail.url, messageDetail.click_track_url)}
        />
      </div>
    );
  }
}

export default withRouter(InboxContent);
